var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-field form-field__input", class: _vm.rootClasses },
    [
      _c("label", [
        !_vm.hasFloatingLabel && _vm.$slots.label
          ? _c(
              "span",
              { staticClass: "form-field--title-label" },
              [_vm._t("label")],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "form-field--input-container",
            attrs: {
              "data-action-count": _vm.countVirtualTags(_vm.$slots.actions)
            }
          },
          [
            _vm.hasFloatingLabel && _vm.$slots.label
              ? _c(
                  "span",
                  { staticClass: "form-field--floating-label" },
                  [_vm._t("label")],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._t("input", [
              _vm.$attrs.type === "checkbox"
                ? _c(
                    "input",
                    _vm._g(
                      _vm._b(
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.currentValue,
                              expression: "currentValue"
                            }
                          ],
                          staticClass: "form-field--input",
                          attrs: { type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(_vm.currentValue)
                              ? _vm._i(_vm.currentValue, null) > -1
                              : _vm.currentValue
                          },
                          on: {
                            focus: _vm.onFocus,
                            blur: _vm.onBlur,
                            change: function($event) {
                              var $$a = _vm.currentValue,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.currentValue = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.currentValue = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.currentValue = $$c
                              }
                            }
                          }
                        },
                        "input",
                        _vm.$attrs,
                        false
                      ),
                      _vm.$listeners
                    )
                  )
                : _vm.$attrs.type === "radio"
                ? _c(
                    "input",
                    _vm._g(
                      _vm._b(
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.currentValue,
                              expression: "currentValue"
                            }
                          ],
                          staticClass: "form-field--input",
                          attrs: { type: "radio" },
                          domProps: { checked: _vm._q(_vm.currentValue, null) },
                          on: {
                            focus: _vm.onFocus,
                            blur: _vm.onBlur,
                            change: function($event) {
                              _vm.currentValue = null
                            }
                          }
                        },
                        "input",
                        _vm.$attrs,
                        false
                      ),
                      _vm.$listeners
                    )
                  )
                : _c(
                    "input",
                    _vm._g(
                      _vm._b(
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.currentValue,
                              expression: "currentValue"
                            }
                          ],
                          staticClass: "form-field--input",
                          attrs: { type: _vm.$attrs.type },
                          domProps: { value: _vm.currentValue },
                          on: {
                            focus: _vm.onFocus,
                            blur: _vm.onBlur,
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.currentValue = $event.target.value
                            }
                          }
                        },
                        "input",
                        _vm.$attrs,
                        false
                      ),
                      _vm.$listeners
                    )
                  )
            ]),
            _vm._v(" "),
            _c("ui-actions", [_vm._t("actions")], 2)
          ],
          2
        )
      ]),
      _vm._v(" "),
      _vm._t("messages")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-58df50de", { render: render, staticRenderFns: staticRenderFns })
  }
}